import { gql } from '@apollo/client';

export const SAVE_USER_MARKETING_INFO = gql`
  mutation SAVE_USER_MARKETING_INFO($marketingInfo: MarketingInfoInput!) {
    isSaved: saveUserMarketingInfo(marketingInfo: $marketingInfo)
  }
`;
